import React, { useEffect, useState } from 'react';
import { formatCurrency, getAlert, parseCurrency, useEscapeClose } from '../../../utils/SamuiUtils';
import { manageWhArPaymentData } from '../../../utils/PaymentUtils';

function EditDebtModal({ isOpen, onClose, item, initialize, paidType }) {
    const [adjustAmount, setAdjustAmount] = useState("0.00");
    const [paymentType, setPaymentType] = useState(""); // "debt" | "none" | "over"

    useEscapeClose(isOpen, onClose);
    
    useEffect(() => {
        setAdjustAmount("0.00");
        setPaymentType("");
    }, [isOpen]);

    if (!item) return null;
    const currentItemOnhand = paidType === 4 ? item.Item_Onhand_Credit : item.Item_Onhand;

    const handleSubmit = async () => {
        try {
            if (!/^-?\d{1,3}(,\d{3})*(\.\d+)?$|^-?\d+(\.\d+)?$/.test(adjustAmount)) return getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");

            if (paymentType === "") {
                return getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
            }

            // เช็กการกรอกจำนวนที่จะปรับปรุงก่อน
            if (!adjustAmount && isNaN(Number(adjustAmount))) return getAlert("FAILED", "กรุณากรอกจำนวนที่ต้องการปรับปรุง");

            // IF => ยอดเป็น + เช่น 200 ก็ต้องไปปรับก่อน -200 จะได้ยอดค้างชำระ = 0  
            // ELSE IF => ยอดเป็น - เช่น -200 ก็ต้องไป ปรับ ก่อน +200 จะได้ยอดค้างชำระ = 0  
            // ELSE => ยอดเป็น 0.00 ก็ไม่ต้องทำอะไร

            if (currentItemOnhand > 0) {
                await manageWhArPaymentData(
                    item.AR_Id,
                    item.AR_Code,
                    item.AR_Name,
                    0,
                    "AO",
                    parseCurrency(currentItemOnhand),
                    null,
                    "ปรับปรุงออก",
                    null,
                    `ปรับยอด${paidType === 4 ? 'เครดิต' : 'ค้างจ่าย'}`,
                    formatCurrency(paidType)
                );
            } else if (currentItemOnhand < 0) {
                await manageWhArPaymentData(
                    item.AR_Id,
                    item.AR_Code,
                    item.AR_Name,
                    0,
                    "AI",
                    parseCurrency(Math.abs(currentItemOnhand)),
                    null,
                    "ปรับปรุงเข้า",
                    null,
                    `ปรับยอด${paidType === 4 ? 'เครดิต' : 'ค้างจ่าย'}`,
                    formatCurrency(paidType)
                );
            } else {
                // ยอดเป็น 0.00 ก็ไม่ต้องทำอะไร
            }

            // IF => ถ้ายอดมากกว่า 0 ให้ ปรับ ยอดใน Input Text เข้าไป   
            // ELSE IF => แต่ถ้ายอด = 0 ไม่ต้องทำอะไร ก็ ปรับ ออก   
            // ELSE IF => ยอดน้อยกว่า 0 ให้ ปรับ ยอดใน Input Text เข้าไป    
            // ELSE => ERROR

            if (paymentType === "debt") {
                await manageWhArPaymentData(
                    item.AR_Id,
                    item.AR_Code,
                    item.AR_Name,
                    0,
                    "AO",
                    -parseCurrency(adjustAmount),
                    null,
                    "ปรับปรุงออก",
                    null,
                    `ปรับยอด${paidType === 4 ? 'เครดิต' : 'ค้างจ่าย'}`,
                    formatCurrency(paidType)
                );
            } else if (paymentType === "none") {
                await manageWhArPaymentData(
                    item.AR_Id,
                    item.AR_Code,
                    item.AR_Name,
                    0,
                    "AO",
                    parseCurrency("0.00"),
                    null,
                    "ปรับปรุงออก",
                    null,
                    `ปรับยอด${paidType === 4 ? 'เครดิต' : 'ค้างจ่าย'}`,
                    formatCurrency(paidType)
                );
            } else if (paymentType === "over") {
                await manageWhArPaymentData(
                    item.AR_Id,
                    item.AR_Code,
                    item.AR_Name,
                    0,
                    "AI",
                    parseCurrency(adjustAmount),
                    null,
                    "ปรับปรุงเข้า",
                    null,
                    `ปรับยอด${paidType === 4 ? 'เครดิต' : 'ค้างจ่าย'}`,
                    formatCurrency(paidType)
                );
            } else {
                getAlert("FAILED", `พบข้อผิดพลาดในการปรับปรุงยอดค้าง${paidType === 4 ? 'เครดิต' : 'ค้างชำระ'}`);
            }

            setAdjustAmount("0.00");
            setPaymentType("");
            onClose();
            initialize();
        } catch (error) {
            getAlert("FAILED", error);
        }
    };

    return (
        <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="modal-header bg-warning text-white">
                        <h4 className="modal-title">ปรับปรุงยอด{paidType === 4 ? "เครดิต" : "ค้างจ่าย"}</h4>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>

                    <div className="modal-body py-4 px-4">
                        <div className="text-center mb-4">
                            <div className="fs-3 fw-bold">{item.AR_Name}</div>
                        </div>

                        <div className="text-center mb-3">
                            <div className="fs-6 text-muted">ยอด{paidType === 4 ? "เครดิต" : "ค้างจ่าย"}ปัจจุบัน</div>
                            <div className="fs-2 fw-bold" style={{ color: currentItemOnhand < 0 ? '#dc3545' : '#28a745' }}>
                                {formatCurrency(currentItemOnhand)} บาท
                            </div>
                        </div>

                        {/* ปุ่มประเภท */}
                        <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap">
                            <button className={`btn ${paymentType === 'debt' ? 'btn-danger' : 'btn-outline-danger'}`} onClick={() => setPaymentType('debt')}>{paidType === 4 ? "เครดิต" : "ค้างจ่าย"}</button>
                            <button className={`btn ${paymentType === 'none' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => {
                                setPaymentType('none');
                                setAdjustAmount("0.00");
                            }}>ไม่{paidType === 4 ? "ค้างเครดิต" : "ค้างจ่าย"}</button>
                            <button className={`btn ${paymentType === 'over' ? 'btn-success' : 'btn-outline-success'}`} onClick={() => setPaymentType('over')}>{paidType === 4 ? "เครดิตเกิน" : "จ่ายเกิน"}</button>
                        </div>

                        {/* ช่องกรอก */}
                        {(paymentType === "debt" || paymentType === "over") && (
                            <div className="mb-3 text-center">
                                <label className="form-label fw-semibold mb-2">จำนวนที่ต้องการปรับ (บาท)</label>
                                <div className="d-flex justify-content-center">
                                    <input
                                        type="text"
                                        className="form-control form-control-md"
                                        style={{ textAlign: 'right', width: '50%' }}
                                        value={adjustAmount || ""}
                                        onChange={(e) => setAdjustAmount(e.target.value)}
                                        onBlur={(e) => setAdjustAmount(formatCurrency(parseCurrency(e.target.value)))}
                                        onFocus={(e) => setAdjustAmount(parseCurrency(e.target.value))}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer px-4 pb-4 justify-content-center">
                        <button className="btn btn-danger px-4 me-3" onClick={onClose}>ยกเลิก</button>
                        <button className="btn btn-success px-4" onClick={handleSubmit}>
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditDebtModal;